import React from 'react'
import { ReactComponent } from './alarm-bell.svg'
import { MergeReactElementProps } from '../types'

interface NotificationsIconProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', NotificationsIconProps>

export const NotificationsIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return <ReactComponent stroke={color} fill="none" ref={ref} {...props} />
  }
)
